import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getSupplierContactRoleListData } from './mockData'
import type { IContactRole } from '~/types/contact/models'

// get

interface GetSupplierContactRolesResponse {
  data: IContactRole[]
}

async function getSupplierContactRoles(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetSupplierContactRolesResponse = {
    data: await getSupplierContactRoleListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postSupplierContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getSupplierContactRoleListData)
}

const patchSupplierContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getSupplierContactRoleListData)
}

const deleteSupplierContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getSupplierContactRoleListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/suppliercontactroles',
    handler: getSupplierContactRoles,
  },
  {
    method: 'post',
    path: '/api/suppliercontactroles',
    handler: postSupplierContactRole,
  },
  {
    method: 'patch',
    path: '/api/suppliercontactroles/:id',
    handler: patchSupplierContactRole,
  },
  {
    method: 'delete',
    path: '/api/suppliercontactroles/:id',
    handler: deleteSupplierContactRole,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
